module.exports = __webpack_public_path__ + "static/media/icon.29b8b774.svg";